<template>
  <div class="policy">
    <job-header-simple header_title="个税计算依据"></job-header-simple>
    <div class="content">
      <h2>一、计算公式</h2>
      <p>本期应预扣预缴税额 = (累计收入 - 累计费用 - 累计免征收入 - 累计减除费用 - 累计依法确定的其他扣除) × 预扣率 - 速算扣除数 - 累计减免税额 - 累计已预扣预缴税额</p>
      
      <p><strong>其中：</strong></p>
      <ol>
        <li>1,累计费用 = 累计收入 × 20%</li>
        <li>2,累计减除费用 = 5000元/月 × n，n为当年当年截至本月在本互联网平台企业连续取得劳务报酬的月份数</li>
        <li>3,预扣率、速算扣除数</li>
      </ol>

      <table border="1" cellpadding="8" cellspacing="0" style="width: 100%; border-collapse: collapse;">
        <thead>
          <tr>
            <th>级数</th>
            <th>全年应纳税所得额</th>
            <th>预扣率</th>
            <th>速算扣除数</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in dataList" :key="item.id">
            <td>{{item.level}}</td>
            <td>{{item.income}}</td>
             <td>{{item.tax}}</td>
            <td>{{item.total}}</td>
          </tr>
        </tbody>
      </table>

      <h3>4. 劳务报酬个税计算区分连续劳务和非连续劳务</h3>
      <p>为减轻从业人员在预扣预缴环节的负担，《国家税务总局关于互联网平台企业为平台内从业人员办理扣缴申报、代办申报若干事项的公告》对从业人员取得劳务报酬所得预扣预缴的方法进行了调整，允许按照累计预扣法预扣预缴税款，既可以扣除每月5000元的减除费用，还可以按照3%-45%的七级累进预扣税率计算税款。可参考例1。</p>

      <h3>例1：</h3>
      <p>张某6月和7月分别自A平台企业取得劳务报酬所得7000元和7500元，8月和9月未取得劳务报酬所得，10月、11月和12月分别取得劳务报酬所得7200元、6000元和8000元。</p>

      <p>按照现行预扣预缴方法，张某每个月需要预缴的税款分别为：</p>
      <p>6月：7000×(1-20%)×20%=1120元；</p>
      <p>7月：7500×(1-20%)×20%=1200元；</p>
      <p>10月：7200×(1-20%)×20%=1152元；</p>
      <p>11月：6000×(1-20%)×20%=960元；</p>
      <p>12月：8000×(1-20%)×20%=1280元。</p>

      <p><strong>合计需要预缴税款5712元。</strong></p>

      <p>按照调整后的办法，采用累计计扣法，张某每个月需要预缴的税款分别为：</p>
      <p>6月：[7000×(1-20%)-5000]×3%=18元；</p>
      <p>7月：[7000+7500×(1-20%)-5000×2]×3%-18=30元；</p>
      <p>由于张某8月和9月未取得收入，从10月份开始，需要重新开始累计计算税款。</p>
      <p>10月：[7200×(1-20%)-5000]×3%=22.8元；</p>
      <p>11月：[(7200+6000)×(1-20%)-5000×2]×3%-22.8=-6元，由于应缴税款小于零，本月无需缴税和退税；</p>
      <p>12月：[(7200+6000+8000)×(1-20%)-5000×3]×3%-22.8=36元。</p>
      <p><strong>合计需要预缴税款106.8元，比调整方法前少预缴税款5605.2元。</strong></p>

      <h2>二、国家税务总局规范性文件</h2>
      <p><strong>国家税务总局公告2025年第15号<a class="link-a" href="https://fgk.chinatax.gov.cn/zcfgk/c100012/c5241477/content.html">《国家税务总局关于互联网平台企业报送涉税信息有关事项的公告》</a></strong></p>
      <p>关于<a class="link-a" href="https://fgk.chinatax.gov.cn/zcfgk/c100015/c5241480/content.html">《国家税务总局关于互联网平台企业报送涉税信息有关事项的公告》</a>的解读</p>

      <p><strong>国家税务总局公告2025年第16号<a class="link-a" href="https://fgk.chinatax.gov.cn/zcfgk/c100012/c5241472/content.html">《国家税务总局关于互联网平台企业为平台内从业人员办理扣缴申报、代办申报若干事项的公告》</a></strong></p>
      <p>关于<a class="link-a" href="https://fgk.chinatax.gov.cn/zcfgk/c100015/c5241475/content.html">《国家税务总局关于互联网平台企业为平台内从业人员办理扣缴申报、代办申报若干事项的公告》</a>的解读</p>
    </div>
  </div>
</template>

<script>
import jobHeaderSimple from "@/components/header/header.vue";

export default {
  components: {
    jobHeaderSimple
  },
  created() {
    
  },
  data() {
    return {
     dataList:[
        {
            level:1,
            income:"收入≤3.6万元",
            tax:"3%",
            total:0,
            id:1
        },
        {
            level:2,
            income:"3.6万元<M≤14.4万元",
            tax:"10%",
            total:2520,
            id:2
        },
        {
            level:3,
            income:"14.4万元<M≤30万元",
            tax:"20%",
            total:16920,
            id:3
        },
        {
            level:4,
            income:"30万元<M≤42万元",
            tax:"25%",
            total:31920,
            id:4
        },
        {
            level:5,
            income:"42万元<M≤66万元",
            tax:"30%",
            total:52920,
            id:5
        },
        {
            level:6,
            income:"66万元<M≤96万元",
            tax:"35%",
            total:85920,
            id:6
        },
        {
            level:7,
            income:"M>96万元",
            tax:"45%",
            total:181920,
            id:7
        }
      ]
    }
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.policy {
  .content {
    .link-a{
        color: #222;
        text-decoration: underline;
        &:active{
             color: #222;
        }
    
    }
    font-size: 12px;
    padding: 8px 12px;
    h2 {
      font-size: 14px;
      margin-bottom: 10px;
    }
    h3 {
      font-size: 13px;
      margin-top: 15px;
      margin-bottom: 8px;
    }
    p {
      margin-bottom: 8px;
      line-height: 1.5;
    }
    ol {
      margin-left: 20px;
      margin-bottom: 10px;
    }
    table {
      margin: 15px 0;
      border: 1px solid #ddd;
      background: #fff;
      th, td {
        padding: 8px;
        text-align: left;
        border: 1px solid #ddd;
      }
      th {
        background-color: #f5f5f5;
      }
    }
  }
  .moveTop {
    margin-top: -36px;
  }
}
</style>